import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";

//COMPONENTS
import AdminLoginSettings from "./files/loginSettings";

function PodRouter() {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(true);
    });

    return (
        <div style={{ height: "100%" }}>
            {isLoaded && (
                <div style={{ height: "100%" }}>
                    <Routes>
                        <Route path="/" element={<AdminLoginSettings />} />
                    </Routes>
                </div>
            )}
        </div>
    );
}

export default PodRouter;
